/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Digital_Vault_Links_OptionalInputs */

const en_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Vault Links (Optional)`)
};

const es_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlaces de Bóveda Digital (Opcional)`)
};

const fr_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liens de Coffre Numérique (Facultatif)`)
};

const de_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitale Tresor-Links (Optional)`)
};

const ja_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デジタル保管庫リンク (任意)`)
};

const zh_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字保险库链接 (可选)`)
};

const ar_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روابط القبو الرقمي (اختياري)`)
};

const id_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan Brankas Digital (Opsional)`)
};

const it_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Cassaforte Digitale (Opzionale)`)
};

const ru_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылки на Цифровое Хранилище (Необязательно)`)
};

const pt_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Links do Cofre Digital (Opcional)`)
};

const ko_digital_vault_links_optional = /** @type {(inputs: Digital_Vault_Links_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디지털 금고 링크 (선택 사항)`)
};

/**
* | output |
* | --- |
* | "Digital Vault Links (Optional)" |
*
* @param {Digital_Vault_Links_OptionalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const digital_vault_links_optional = /** @type {((inputs?: Digital_Vault_Links_OptionalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Digital_Vault_Links_OptionalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_digital_vault_links_optional(inputs)
	if (locale === "es") return es_digital_vault_links_optional(inputs)
	if (locale === "fr") return fr_digital_vault_links_optional(inputs)
	if (locale === "de") return de_digital_vault_links_optional(inputs)
	if (locale === "ja") return ja_digital_vault_links_optional(inputs)
	if (locale === "zh") return zh_digital_vault_links_optional(inputs)
	if (locale === "ar") return ar_digital_vault_links_optional(inputs)
	if (locale === "id") return id_digital_vault_links_optional(inputs)
	if (locale === "it") return it_digital_vault_links_optional(inputs)
	if (locale === "ru") return ru_digital_vault_links_optional(inputs)
	if (locale === "pt") return pt_digital_vault_links_optional(inputs)
	return ko_digital_vault_links_optional(inputs)
});